import {
  CallConfirmation,
  CallConfirmationProps,
} from '@pages/agent/InboxPage/components/CallConfirmation';
import {
  ClassificationModal,
  ClassificationModalProps,
} from '@pages/agent/InboxPage/components/ClassificationModal';
import { ModalId } from './types';
import SimpleConfirmationModal, {
  SimpleConfirmationModalProps,
} from '@components/SimpleConfirmationModal/SimpleConfirmationModal';
import ResetAccountModal, {
  ResetAccountModalProps,
} from '@app/layouts/MainLayout/components/NavBar/components/ResetAccountModal/ResetAccountModal';

type ModalFactoryMap = {
  [key in ModalId]: (props: any) => JSX.Element;
};

export const ModalFactory: ModalFactoryMap = {
  [ModalId.CallConfirmation]: (props: CallConfirmationProps) => (
    <CallConfirmation {...props} />
  ),
  [ModalId.CallClassification]: (props: ClassificationModalProps) => {
    return <ClassificationModal {...props} />;
  },
  [ModalId.SimpleConfirmationModal]: (props: SimpleConfirmationModalProps) => {
    return <SimpleConfirmationModal {...props} />;
  },
  [ModalId.ResetAccountModal]: (props: ResetAccountModalProps) => {
    return <ResetAccountModal {...props} />;
  },
  // Add more modals here as needed
};
